// extracted by mini-css-extract-plugin
export default {"paginaton":"paginaton--HTdUA","page":"page--GBxVE"};